module.exports = {
      id: "video-play-btn-usage",
      viewBox: "0 0 82 82",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#video-play-btn",
      toString: function () {
        return this.url;
      }
    }